import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function Login({ onlyResponsabile = false }) {
  const { login, loginResponsabile } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [gruppo, setGruppo] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      if (onlyResponsabile) {
        await loginResponsabile(gruppo, password);
        navigate("/responsabile");
      } else {
        await login(email, password);
        navigate("/produzione");
      }
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid-bg flex items-center justify-center px-4">
      <div className="w-full max-w-md glass rounded-2xl p-8 fade-in">
        <div className="flex flex-col items-center mb-6">
          <img src="/logo.png" alt="Gigli Edition" className="h-20 w-auto mb-4" />
          <p className="text-sm text-slate-500 mt-1">
            {onlyResponsabile ? "Portale Responsabile — accedi con il nome del tuo gruppo" : "Accedi al centro di controllo"}
          </p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          {onlyResponsabile ? (
            <div>
              <label className="text-xs uppercase tracking-wider text-slate-400 font-semibold">Fans / Comitato / Band</label>
              <input
                data-testid="login-gruppo-input"
                type="text"
                value={gruppo}
                onChange={(e) => setGruppo(e.target.value)}
                placeholder=""
                className="mt-1.5 w-full bg-slate-900/60 border border-slate-700 rounded-lg px-4 py-2.5 text-slate-100 focus:outline-none focus:border-amber-400/60 transition-colors"
                required
              />
            </div>
          ) : (
            <div>
              <label className="text-xs uppercase tracking-wider text-slate-400 font-semibold">Email</label>
              <input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 w-full bg-slate-900/60 border border-slate-700 rounded-lg px-4 py-2.5 text-slate-100 focus:outline-none focus:border-cyan-400/60 transition-colors"
                required
              />
            </div>
          )}
          <div>
            <label className="text-xs uppercase tracking-wider text-slate-400 font-semibold">Password</label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 w-full bg-slate-900/60 border border-slate-700 rounded-lg px-4 py-2.5 text-slate-100 focus:outline-none focus:border-cyan-400/60 transition-colors"
              required
            />
          </div>
          {error && (
            <div data-testid="login-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2">
              {error}
            </div>
          )}
          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            className={`w-full font-semibold rounded-lg py-2.5 transition-colors flex items-center justify-center gap-2 disabled:opacity-60 ${onlyResponsabile ? "bg-amber-400 hover:bg-amber-300 text-slate-900" : "bg-cyan-400 hover:bg-cyan-300 text-slate-900"}`}
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            Accedi
          </button>
        </form>
      </div>
    </div>
  );
}
